import "./Header.scss";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { ENVIRONMENT } from "~shared/constants.ts";
import logo from "/app-logo.png";
import { AppSettings } from "./components/AppSettings/AppSettings.tsx";
import NotificationsPopover from "./components/NotificationsPopover/NotificationsPopover";
import { UserProfile } from "./components/UserProfile/UserProfile.tsx";

export const Header = () => {
  const { formatMessage } = useIntl();

  const appTitle =
    ENVIRONMENT === "prod"
      ? formatMessage({ id: "pageTitles.applicationName" })
      : `${formatMessage({ id: "pageTitles.applicationName" })} - ${ENVIRONMENT}`;

  return (
    <div className="app-header">
      <div className="app-info">
        <div className="app-logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="app-title">{appTitle}</div>
      </div>
      <div className="user-info">
        <UserProfile />
        <NotificationsPopover />
        <AppSettings />
      </div>
    </div>
  );
};
